import { isEmpty as _isEmpty, size } from 'lodash';

/**
 * Checks if the value is a non-empty string (excluding whitespace-only strings)
 * @param str - The value to check
 * @returns True if the value is a string with non-whitespace characters
 */
export const isNonEmptyString = (str: any): boolean => {
  return typeof str === 'string' && str.trim().length > 0;
};

/**
 * Type guard that checks if the value is a valid non-empty array
 * @param arr - The value to check
 * @returns True if the value is an array with at least one element
 */
export const isValidNonEmptyArray = (arr: any): arr is any[] => {
  return Array.isArray(arr) && arr.length > 0;
};

// Re-export lodash utilities with aliases for consistency
export { isEmpty, isBoolean, size as getLength } from 'lodash';
export const isNonEmptyArray = (arr: any): boolean => !_isEmpty(arr) && Array.isArray(arr);
export const hasLength = (value: any): boolean => size(value) > 0;
export const safeLength = (value: any): number => {
  try {
    return size(value);
  } catch {
    return 0;
  }
};
